<app-header></app-header><div class="container">
  <div class="breadcrumbs mt-4">
    <div routerLink="/">Главная</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/">Экспертиза промышленной безопасности</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expertkltp">Проведение экспертизы промышленной безопасности (ЭПБ)</div>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9 18L15 12L9 6" stroke="black" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
    <div routerLink="/expprombez/epb-gpm">Экспертиза промышленной безопасности кранов
    </div>

  </div>
  <div class="row">
    <h1 class="w-100 mt-70">Экспертиза промышленной безопасности кранов
    </h1>
    <ul class="link-arrow">
      <li>- В Москве и регионах</li>
      <li>- В сжатые сроки</li>
      <li>- Квалифицированные эксперты</li>
      <li>- Большой опыт</li>
      <li>- Комплексный подход</li>
    </ul>

    <p>Согласно <strong>Федеральному закону от 21.07.1997 № 116-ФЗ &quot;О промышленной безопасности опасных производственных объектов&quot;</strong>, экспертиза промышленной безопасности грузоподъемных кранов, эпб мостовых кранов, талей, люлек, подъемников и прочих устройств требуется:</p>

    <ul class="marked ml-50">
      <li>перед началом их использования, вводом в эксплуатацию ГПМ, бывших в употреблении, при отсутствии сертификации;</li>
      <li>по завершении срока службы или отсутствии сведений о нем в документации или в ранее выданном заключении эпб на грузоподъемные механизмы;</li>
      <li>в случае проведения ремонтных работ, связанных с изменением конструкции или заменой материалов.</li>
    </ul>

    <h2>Специалисты ООО &laquo;Протос Экспертиза&raquo;:</h2>

    <ul class="marked ml-50">
      <li>Проведут эпб кранов и других грузоподъемных механизмов в соответствии с Федеральными нормами и правилами;</li>
      <li>Разработают паспорта;</li>
      <li>Окажут содействие в регистрации заключения экспертизы промышленной безопасности в Ростехнадзоре;</li>
      <li>Проконсультируют на любом этапе.</li>
    </ul>
    <app-recall-form heading="Напишите Ваш вопрос, и наши специалисты дадут Вам необходимые разъяснения."></app-recall-form>
    <div class="blue-block yellow-block">
    Экспертиза подъемников, кранов-манипуляторов, автокранов и других грузоподъемных механизмов, относящихся к опасным производственным объектам, проводится в соответствии с <strong>Федеральными нормами и правилами в области промышленной безопасности</strong>, утвержденными Приказом Ростехнадзора от 20 октября 2020 года № 420.
    </div>
    <h2>Этапы проведения ЭПБ грузоподъемных механизмов:</h2>

    <ol class="marked" style="margin-left: 14px;">
      <li>Сбор и анализ документации, включая паспорта технических устройств для проведения экспертизы промышленной безопасности, в том числе оценка фактического состояния ГПМ, динамические и статические испытания, а также проведение диагностики с использованием методов неразрушающего контроля, который требуется по истечении срока службы, после восстановительного ремонта и т.д.</li>
      <li>Подготовка заключения по результатам ЭПБ (по результатам проведения экспертизы промышленной безопасности выдается&nbsp;заключение,&nbsp;содержащее наименование, данные об экспертах, заказчике и объекте экспертизы, цель проведения и ее результаты, выводы экспертизы с указанием срока безопасной эксплуатации и другие сведения).&nbsp;</li>
      <li>Внесение заключения в государственный реестр.</li>
    </ol>

    <p>В зависимости от грузоподъемности и типа применения, к ОПО могут относиться следующие грузоподъемные механизмы: мостовые краны, консольные краны, электрические тали, стреловые краны, краны-манипуляторы, автокраны и другие.</p>
    <p><strong>У ООО &laquo;Протос Экспертиза&raquo; большой опыт работы в области промышленной безопасности. Мы полностью соблюдаем сроки, указанные в договорных документах, и сопровождаем процесс от проведения экспертизы до постановки на учет ГПМ и регистрации заключения в государственном реестре. Стоимость рассчитывается индивидуально.</strong></p>
    <app-atomka-calc class="w-100" heading="Получить консультацию по экспертизе промышленной безопасности грузоподъемных кранов, цене и условиям"></app-atomka-calc>
    <app-reviews-block class="w-100"></app-reviews-block>
  </div>
</div>
<app-footer></app-footer>
